// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"47c6a07f","997":"a1214492"}[chunkId] + ".chunk.css";
};